function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "\u5F62\u72B6");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "\\u9875\\u9762-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "\\u5BC6\\u7801\\u91CD\\u7F6E\\u6210\\u529F",
  transform: "translate(-920.000000, -256.000000)",
  fill: "#30CE70"
}, React.createElement("path", {
  d: "M960,256 C982.09139,256 1000,273.90861 1000,296 C1000,318.09139 982.09139,336 960,336 C937.90861,336 920,318.09139 920,296 C920,273.90861 937.90861,256 960,256 Z M982,279.333333 C981.523985,279.333333 981.086812,279.499631 980.743406,279.777299 C980.446092,280.017699 971.591108,287.562708 954.178455,302.412325 C953.672117,302.844133 952.924916,302.836495 952.427512,302.394426 L952.167939,302.163705 C946.930068,297.508264 944.150349,295.028984 943.82878,294.725865 C943.35135,294.275825 942.707886,294 942,294 C940.527241,294 939.333333,295.193907 939.333333,296.666667 C939.333333,297.265625 939.530803,297.818462 939.86419,298.263625 C940.17099,298.673287 944.339067,302.828733 952.36842,310.729962 C953.148412,311.497508 954.400443,311.49567 955.178178,310.725837 L955.734076,310.175595 C973.98755,292.107381 983.231915,282.946363 983.467171,282.692541 C983.797852,282.335763 984,281.858155 984,281.333333 C984,280.228764 983.104569,279.333333 982,279.333333 Z",
  id: "\\u5F62\\u72B6"
})));

var SvgSuccess = function SvgSuccess(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSuccess, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/success.b9b13a70.svg";
export { ForwardRef as ReactComponent };